<template>
  <div class="distrbution">
    <el-card>
      <div class="title">
        <span></span>
        <p>
          {{ title }}
        </p>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.distrbution {
  .title {
    display: flex;
    align-items: center;

    span {
      width: 2px;
      height: 16px;
      background: #0079fe;
      margin: 0 10px 0 0px;
    }
  }
}
</style>
